import {
  ButtonType,
  CaesarsButton,
  PanelContainer,
  SVG,
  useIsDesktop,
  useIsWeb,
} from '@eCommerce/frontend-legacy-shared-library-native';
import ADD_PAYMENT from 'assets/add_payment.svg';
import {Box, Text, View} from 'native-base';
import {useSelector} from 'Provider';
import React from 'react';
import {useTheme} from 'styled-components/native';

import {trackEvent} from 'utils/trackEvent';
import CreditCardCTA from '../CreditCardCTA';

export interface PaymentInfoEmptyStateModuleProps {
  onAddPaymentPressed: () => void;
}

export interface PaymentRemovedFooterProps {
  bgColor: string;
}

const PaymentEmptyStateModule: React.FC<PaymentInfoEmptyStateModuleProps> = ({
  onAddPaymentPressed,
}) => {
  const isDesktop = useIsDesktop();
  const isWeb = useIsWeb();
  const {colors} = useTheme() as any;
  const {tuna, caesarRewards} = colors;

  const onCRVisaButtonPress = () => {
    trackEvent({event: 'caesars_rewards_visa'});
    if (isWeb) {
      window.open(
        'https://www.caesars.com/myrewards/partners/cr-visa',
        '_blank'
      );
    }
  };

  return (
    <PanelContainer
      contentMaxWidth="1170px"
      panelTitle={isDesktop ? '' : 'ADD A PAYMENT METHOD'}
      icon={isDesktop ? '' : 'credit-card'}
      primaryCTA={
        isDesktop
          ? {
              label: 'Add A Payment Method',
              onPress: onAddPaymentPressed,
            }
          : undefined
      }>
      <View alignItems="center">
        <Box
          mb={isDesktop ? '64px' : undefined}
          justifyContent="center"
          alignItems="center"
          maxWidth={isDesktop ? '678px' : undefined}>
          <SVG
            source={ADD_PAYMENT}
            height={isDesktop ? 164 : 160}
            width={isDesktop ? 178 : 178}
          />
          <Text
            fontFamily="heading"
            fontWeight="bold"
            fontSize={isDesktop ? '36px' : '18px'}
            lineHeight={isDesktop ? '44px' : '32px'}
            textAlign="center"
            paddingTop={isDesktop ? '48px' : '30px'}
            paddingBottom={isDesktop ? '32px' : '24px'}
            color={tuna}>
            ADD A PAYMENT METHOD
          </Text>
          <Text
            fontFamily="body"
            fontSize={isDesktop ? '18px' : '14px'}
            lineHeight={isDesktop ? '30px' : '24px'}
            textAlign="center"
            color={tuna}>
            Great news. The easiest way to make reservations is also the most
            secure. Just add a card to start booking rooms, tables, and more.
          </Text>
        </Box>
        {!isDesktop && (
          <Box minWidth={'100%'} paddingTop={'32px'} paddingBottom={'24px'}>
            <CaesarsButton
              isFullWidth={true}
              title="Add A Payment Method"
              onPress={onAddPaymentPressed}
              color={caesarRewards}
              type={ButtonType.PRIMARY}
            />
          </Box>
        )}
      </View>
    </PanelContainer>
  );
};

export default PaymentEmptyStateModule;
